import { AxiosResponse } from "axios";
import publicClient from "./publicClient";
import { DirectoryFilters, DirectoryResults, PublicProfile } from "../../domain/types";

function toParams(filters: DirectoryFilters): Record<string, string | number> {
    const params: Record<string, string | number> = {};
    if (filters.q) params.q = filters.q;
    if (filters.problem) params.problem = filters.problem;
    if (filters.therapyType) params.therapy_type = filters.therapyType;
    if (filters.modality) params.modality = filters.modality;
    if (filters.language) params.language = filters.language;
    if (filters.city) params.city = filters.city;
    if (filters.offset) params.offset = filters.offset;
    return params;
}

export const PublicDirectoryAPI = {
    search: (
        filters: DirectoryFilters = {},
    ): Promise<AxiosResponse<DirectoryResults>> =>
        publicClient.get("/public/therapists", { params: toParams(filters) }),

    profile: (slug: string): Promise<AxiosResponse<PublicProfile>> =>
        publicClient.get(`/public/therapists/${encodeURIComponent(slug)}`),
};
